export const duplicatesCardInfo = {
	title: "Duplicates",
	subtitle: "Duplicate",
	dueDate: "Due date",
	value: "Value",
};
